// extracted by mini-css-extract-plugin
export default {"specificProduct":"PrimaryProduct_specificProduct__9uuWY","description":"PrimaryProduct_description__Zh4iY"};